import { render, staticRenderFns } from "./LoanStatusDates.vue?vue&type=template&id=1ffac23f&"
import script from "./LoanStatusDates.vue?vue&type=script&lang=js&"
export * from "./LoanStatusDates.vue?vue&type=script&lang=js&"
import style0 from "./LoanStatusDates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports